/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Modal, Tabs, Dropdown } from "rsuite";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import * as ReportService from "services/reportServices";
import * as SettingsServices from "services/settingsServices";
import PageHeaderComponent from "components/common/pageHeaderComponent";
import Constants from "utils/constants";
import TableComponent from "../../common/tableComponent";
import { Icon } from "@iconify/react";
import moment from "moment";
import { ReportOOSConstants } from "./ReportOutOfStockConstants";
import * as UMSService from "services/umsService";
import * as AuthService from "services/authService";

import { add, addDays } from "date-fns";
const ReportOutOfStockComp = (props: any) => {
  const [allVendorName, setAllVendorName] = useState([]);
  const [vendorID, setVendorID] = useState(allVendorName[1]);

  const [allOOSData, setAllOOSData] = useState([]);
  const [invoicedData, setInvoicedData] = useState([]);
  const [reasonsData, setReasonsData] = useState([]);
  const [notOrderedData, setNotOrderedData] = useState([]);
  const [orderExtraData, setOrderExtraData] = useState([]);
  const [notSentData, setNotSentData] = useState([]);
  const [fromDate, setFromDate] = useState<Date>(addDays(new Date(), -1));
  const [toDate, setToDate] = useState<Date>(addDays(new Date(), -1));
  // const [toDate, setToDate] = useState<Date>(new Date());

  const [storeName, setStoreName] = useState([]);
  const [storeNameHeader, setStoreNameHeader] = useState([]);
  const [storeID, setStoreID] = useState([]);
  const [userStore, setUserStore] = useState(storeID[0]);
  const [awgOrGotSelect, setAwgOrGotSelect] = useState(1);
  const [groupTypeID, setGroupTypeID] = useState(null);
  const [selectedReportType, setSelectedReportType] = useState("");
  const [tabsActiveKey, setTabsActiveKey] = useState("All");

  const [selectedReportConstantName, setSelectedReporConstantName] = useState(
    ReportOOSConstants["General"]
  );
  const [selectedReportTableName, setSelectedReporTableName] = useState([]);
  const [detailData, setDetailData] = useState([]);
  const [detailRowData, setDetailRowData] = useState([]);

  const { userContext = {} } = props;
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    getReportData(
      userContext && userContext.store ? userContext.store : userStore
    );
  }, [userStore, storeNameHeader, fromDate, toDate, userContext, vendorID]);
  useEffect(() => {
    if (userContext && userContext.roleName === "Super Admin") {
      getVendorStoreName(groupTypeID);
    } else if (
      userContext &&
      userContext.groupType &&
      userContext.groupTypeId !== 0
    ) {
      getVendorStoreName(userContext.groupTypeId);
    } else if (
      userContext &&
      !userContext.store &&
      userContext.groupType &&
      userContext.groupTypeId === 0
    ) {
      getVendorStoreName(groupTypeID);
    } else if (userContext && userContext.store) {
      getVendorStoreName(userContext.store);
    }
  }, [groupTypeID, userContext]);

  const [groupAndGroupID, setGroupAndGroupID] = useState([
    { groupStore_uid: "", groupStore_desc: "" },
  ]);

  const awgOrGot = [
    { groupStore_uid: "1", groupStore_desc: "GOT" },
    { groupStore_uid: "2", groupStore_desc: "AWG" },
  ];
  const getVendorStoreName = async (grouptypeID1 = "") => {
    const { handleSpinner, userContext } = props;
    const { user_ID, store } = userContext;
    var storesArray = [];
    const uniqueVendor = new Set();
    AuthService.getDMStores(user_ID)
      .then((result1) => {
        result1.records.map((item) => storesArray.push(item.stores));
      })
      .catch((err) => {
        console.error("Error: Get Data - ", err);
        // toast.error("Error Loading Orders");
      });
    if (store) {
        SettingsServices.getVendorStoreName(store, "Store")
        .then((result) => {
          result.records.forEach((item) => {
            const { vendor_ID, vendor_Name } = item;
            uniqueVendor.add(JSON.stringify({ vendor_ID, vendor_Name }));
          });
          const uniqueVendorData = Array.from(uniqueVendor).map((store) =>
            JSON.parse(store as string)
          );
          setAllVendorName(uniqueVendorData);
          setVendorID(uniqueVendorData[0].vendor_ID.toString());
          result.records.sort((a, b) => {
            const Store_A = a.store_ID;
            const Store_B = b.store_ID;

            if (Store_A < Store_B) {
              return -1;
            } else if (Store_A > Store_B) {
              return 1;
            } else {
              return 0;
            }
          });
          if (storesArray.length >= 1) {
            result.records = result.records.filter((item) =>
              storesArray.includes(item.store_ID.toString())
            );
          }
          //console.log("StoreName: Result - ", result.records);
          var setArrayID = [];
          var setArrayName = [];
          result.records.filter((item) => {
            if (!setArrayID.includes(item.store_ID)) {
              setArrayID.push(item.store_ID);
            }
          });
          result.records.filter((item) => {
            if (!setArrayName.includes(item.store_Name)) {
              setArrayName.push(item.store_Name);
            }
          });

          setStoreName(setArrayName);
          setUserStore(setArrayID[0]);
          setStoreID(setArrayID);
        })
        .catch((err) => {
          console.error("Error: Get Data - ", err);
          // toast.error("Error Loading Orders");
        })
        .finally(() => {
          handleSpinner && handleSpinner(false);
        });
    } else {
      SettingsServices.getVendorStoreName(grouptypeID1, "")
        .then((result) => {
          result.records.forEach((item) => {
            const { vendor_ID, vendor_Name } = item;
            uniqueVendor.add(JSON.stringify({ vendor_ID, vendor_Name }));
          });
          const uniqueVendorData = Array.from(uniqueVendor).map((store) =>
            JSON.parse(store as string)
          );
          setAllVendorName(uniqueVendorData);
          setVendorID(uniqueVendorData[0].vendor_ID.toString());
          result.records.sort((a, b) => {
            const Store_A = a.store_ID;
            const Store_B = b.store_ID;

            if (Store_A < Store_B) {
              return -1;
            } else if (Store_A > Store_B) {
              return 1;
            } else {
              return 0;
            }
          });
          if (storesArray.length >= 1) {
            result.records = result.records.filter((item) =>
              storesArray.includes(item.store_ID.toString())
            );
          }
          //console.log("StoreName: Result - ", result.records);
          var setArrayID = [];
          var setArrayName = [];
          result.records.filter((item) => {
            if (!setArrayID.includes(item.store_ID)) {
              setArrayID.push(item.store_ID);
            }
          });
          result.records.filter((item) => {
            if (!setArrayName.includes(item.store_Name)) {
              setArrayName.push(item.store_Name);
            }
          });

          setStoreName(setArrayName);
          setUserStore(setArrayID[0]);
          setStoreID(setArrayID);
        })
        .catch((err) => {
          console.error("Error: Get Data - ", err);
          // toast.error("Error Loading Orders");
        })
        .finally(() => {
          handleSpinner && handleSpinner(false);
        });
    }
  };

  useEffect(() => {
    if (
      userContext &&
      userContext.groupType === 2 &&
      userContext.groupTypeId === 0 &&
      userContext.roleId !== 3
    )
      GetFirstAllStore("2", "StoreType");

    if (
      userContext &&
      userContext.groupType === 1 &&
      userContext.groupTypeId === 0 &&
      userContext.roleId !== 3
    )
      GetFirstAllStore("1", "StoreType");

    if (
      userContext &&
      userContext.groupType === 3 &&
      userContext.groupTypeId === 0 &&
      userContext.roleId !== 3
    )
      GetFirstAllStore("3", "StoreType");
  }, [userContext]);

  useEffect(() => {
    if (userContext && !userContext.store) {
      SettingsServices.getVendorStoreName(userStore, "Store")
        .then((result) => {
          //console.log("StoreName: Result - ", result.records);
          const uniqueVendor = new Set();
          result.records.forEach((item) => {
            const { vendor_ID, vendor_Name } = item;
            uniqueVendor.add(JSON.stringify({ vendor_ID, vendor_Name }));
          });
          const uniqueVendorData = Array.from(uniqueVendor).map((store) =>
            JSON.parse(store as string)
          );

          uniqueVendorData.sort((a, b) => {
            const Store_A = a.vendor_Name;
            const Store_B = b.vendor_Name;

            if (Store_A < Store_B || Store_A.includes("AWG KC")) {
              return -1;
            } else if (Store_A > Store_B) {
              return 1;
            } else {
              return 0;
            }
          });
          setAllVendorName(uniqueVendorData);
          setVendorID(uniqueVendorData[0].vendor_ID.toString());
        })
        .catch((err) => {
          console.error("Error: Get Data - ", err);
          // toast.error("Error Loading Orders");
        })
        .finally(() => {});
    }
  }, [userStore, userContext]);
  //#region Get Group and Store by Types
  const GetFirstAllStore = async (IDType, operation) => {
    userContext &&
      !userContext.store &&
      UMSService.GetGroupAndStoreByTypes(IDType, operation)
        .then((result) => {
          var setArrayName = [];
          var setArrayID = [];
          if (IDType === "2") {
            result.map((item) => {
              return (item.groupStore_desc =
                item.groupStore_uid + " / " + item.groupStore_desc);
            });
          }
          result.sort((a, b) => {
            const Store_A = a.groupStore_uid;
            const Store_B = b.groupStore_uid;

            if (Store_A < Store_B) {
              return -1;
            } else if (Store_A > Store_B) {
              return 1;
            } else {
              return 0;
            }
          });

          result.filter((item) => {
            if (!setArrayID.includes(item.groupStore_uid)) {
              setArrayID.push(item.groupStore_uid);
            }
          });
          result.filter((item) => {
            if (!setArrayName.includes(item.groupStore_desc)) {
              setArrayName.push(item.groupStore_desc);
            }
          });
          setStoreName(setArrayName);
          setUserStore(setArrayID[0]);
          setStoreID(setArrayID);
        })
        .catch((err) => {
          console.error("Error:  - ", err);
          // toast.error("Error Loading Orders");
        });
  };

  useEffect(() => {
    if (
      userContext &&
      userContext.roleName &&
      userContext.roleName === "Super Admin"
    ) {
      GetGroupAndStoreByTypes(awgOrGotSelect, "GroupType");
    } else if (
      userContext &&
      userContext.groupType &&
      userContext.groupTypeId === 0 &&
      userContext.groupType === 1
    ) {
      GetGroupAndStoreByTypes("1", "GroupType");
    } else if (
      userContext &&
      userContext.groupType &&
      userContext.groupTypeId === 0 &&
      userContext.groupType === 2
    ) {
      GetGroupAndStoreByTypes("2", "GroupType");
    } else if (
      userContext &&
      userContext.groupType &&
      userContext.groupTypeId &&
      userContext.groupType === "" &&
      userContext.store !== 0
    ) {
      getStoreName(userContext.store);
    }
  }, [props.userContext, awgOrGotSelect]);

  const GetGroupAndStoreByTypes = async (IDType, operation) => {
    UMSService.GetGroupAndStoreByTypes(IDType, operation)
      .then((result) => {
        if (IDType === "2") {
          result.map((item) => {
            return (item.groupStore_desc =
              item.groupStore_uid + " / " + item.groupStore_desc);
          });
        }
        result.sort((a, b) => {
          const Store_A = a.groupStore_desc.toUpperCase();
          const Store_B = b.groupStore_desc.toUpperCase();

          if (Store_A < Store_B) {
            return -1;
          } else if (Store_A > Store_B) {
            return 1;
          } else {
            return 0;
          }
        });
        setGroupAndGroupID(result);
      })
      .catch((err) => {
        console.error("Error:  - ", err);
        // toast.error("Error Loading Orders");
      });
  };

  const getReportData = async (storeID) => {
    const { handleSpinner, userContext = {} } = props;
    const { store } = userContext;

    const changeZeroToString = (array) => {
      for (var i = 0; i < array.length; i++) {
        var item = array[i];

        for (var key in item) {
          if (item[key] === 0) {
            item[key] = "";
          }
        }
      }
    };
    if (store !== 0) {
      handleSpinner && handleSpinner(true);
      ReportService.getOutOfStock(
        vendorID,
        storeID,
        moment(fromDate).format("MM-DD-YYYY"),
        moment(toDate).format("MM-DD-YYYY")
      )
        .then((result) => {
          setAllOOSData(result.allRecords);
          setSelectedReporTableName(result.allRecords);
          setInvoicedData(result.invoicedRecords);
          setReasonsData(result.reasonsRecords);
          setNotOrderedData(result.notOrderedRecords);
          setOrderExtraData(result.orderExtraRecords);
          setNotSentData(result.notSentRecords);
          result && setSelectedReportType("All");
        })
        .catch((err) => {
          console.error("Error: Get Orders - ", err);
          // toast.error("Error Loading Orders");
        })
        .finally(() => {
          handleSpinner && handleSpinner(false);
        });
    } else {
      handleSpinner && handleSpinner(true);
      ReportService.getOutOfStock(
        vendorID,
        storeID,
        moment(fromDate).format("MM-DD-YYYY"),
        moment(toDate).format("MM-DD-YYYY")
      )
        .then((result) => {
          changeZeroToString(result.allRecords);
          changeZeroToString(result.invoicedRecords);
          changeZeroToString(result.reasonsRecords);
          changeZeroToString(result.notOrderedRecords);
          changeZeroToString(result.orderExtraRecords);
          changeZeroToString(result.notSentRecords);
          setAllOOSData(result.allRecords);
          setInvoicedData(result.invoicedRecords);
          setReasonsData(result.reasonsRecords);
          setNotOrderedData(result.notOrderedRecords);
          setOrderExtraData(result.orderExtraRecords);
          setNotSentData(result.notSentRecords);
          setTabsActiveKey("All");
        })
        .catch((err) => {
          console.error("Error: Get Orders - ", err);
          // toast.error("Error Loading Orders");
        })
        .finally(() => {
          handleSpinner && handleSpinner(false);
        });
    }
  };

  //   const modifyReportData = (data) => {
  //     let modifiedData = data.map((item) => {
  //       item["dateTime_In"] =
  //         item["dateTime_In"] && moment(item["dateTime_In"]).format("MM-DD-YYYY");
  //       item["invoice_Date"] =
  //         item["invoice_Date"] &&
  //         moment(item["invoice_Date"]).format("MM-DD-YYYY");
  //       item["invoice_Date_Next"] =
  //         item["invoice_Date_Next"] &&
  //         moment(item["invoice_Date_Next"]).format("MM-DD-YYYY");
  //       item["delivery_Date"] =
  //         item["delivery_Date"] &&
  //         moment(item["delivery_Date"]).format("MM-DD-YYYY");

  //       item["rec_Date"] =
  //         item["rec_Date"] && moment(item["rec_Date"]).format("MM-DD-YYYY");

  //       return item;
  //     });
  //     return modifiedData;
  //   };

  //#region Excel Export
  const exportToExcel = (excelData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: Constants.fileType });
    FileSaver.saveAs(data, fileName + Constants.fileExtension);
  };
  //#endregion

  //#region Filters Drawer

  //#endregion

  useEffect(() => {
    if (userContext && userContext.store && userContext.store !== 0) {
      getStoreName(userContext.store);
    }
  }, [userContext]);

  const getStoreName = (storeID) => {
    SettingsServices.GetAdGroupandGroupID(storeID)
      .then((result) => {
        setStoreNameHeader(result.records[0].description);
      })
      .catch((err) => {
        console.error("Error: Get Data - ", err);
        // toast.error("Error Loading Orders");
      });
  };

  //   const filterList = (value) => {
  //     if (value) {
  //       setSelectedReporTableName(
  //         selectedReportTableName.filter((item) =>
  //           item.description
  //             .toLowerCase()
  //             .includes(value.toString().toLowerCase())
  //         )
  //       );
  //     } else {
  //       selectedData(selectedReportType);
  //     }
  //   };

  const onOptionChangeVendor = (event) => {
    const VendorAndStore = event.toString();
    setVendorID(VendorAndStore);
    //setShowAllData(true);
  };
  useEffect(() => {
    selectedData(selectedReportType);
  }, [selectedReportType, userStore, allOOSData]);

  const selectedData = (selectedTab) => {
    if (!selectedTab) {
      setSelectedReporConstantName(ReportOOSConstants["GeneralConstants"]);
      setTabsActiveKey("All");
      setSelectedReporTableName(allOOSData);
    } else {
      switch (selectedTab) {
        case "All":
          setSelectedReporTableName(allOOSData);
          break;
        case "Invoiced":
          setSelectedReporTableName(invoicedData);
          break;
        case "Reasons":
          setSelectedReporTableName(reasonsData);
          break;
        case "NotOrdered":
          setSelectedReporTableName(notOrderedData);
          break;
        case "OrderExtra":
          setSelectedReporTableName(orderExtraData);
          break;
        case "NotSent":
          setSelectedReporTableName(notSentData);
          break;
      }
    }
  };

  const getDetailRecord = (data) => {
    const changeZeroToString = (array) => {
      for (var i = 0; i < array.length; i++) {
        var item = array[i];

        for (var key in item) {
          if (item[key] === 0 || item[key] === 0.0) {
            item[key] = "";
          }
        }
      }
    };
    setDetailRowData(data);
    data &&
      ReportService.getOutOfStockDetail(
        vendorID,
        userStore,
        moment(fromDate).format("MM-DD-YYYY"),
        data.department_Store_ID,
        data.item_ID,
        data.upc.toString(),
        data.pack1,
        moment(toDate).format("MM-DD-YYYY")
      )
        .then((result) => {
          result.allRecords.map(
            (item) =>
              (item.delivery_Date = moment(item.delivery_Date).format(
                "MM-DD-YYYY"
              ))
          );

          changeZeroToString(result.allRecords);
          setDetailData(result.allRecords);
          result && setOpen(true);
        })
        .catch((err) => {
          console.error("Error: Get Orders - ", err);
          // toast.error("Error Loading Orders");
        })
        .finally(() => {});
  };
  return (
    <>
      <div>
        <div>
          <div className="d-flex flex-nowrap justify-content-start align-items-center ">
            <>
              <PageHeaderComponent
                setGroupTypeID={setGroupTypeID}
                setAwgOrGotSelect={setAwgOrGotSelect}
                setUserStore={setUserStore}
                userContext={userContext}
                groupAndGroupID={groupAndGroupID}
                awgOrGot={awgOrGot}
                storeName={storeName}
                storeNameHeader={storeNameHeader}
                storeID={storeID}
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
                isVendor={true}
                allVendorName={allVendorName}
                onOptionChangeVendor={onOptionChangeVendor}
                isCalendar={true}
              />

              {/* 
              <InputGroup
                onChange={(event) => {
                  filterList(event.target.value);
                }}
                style={{
                  width: 220,
                  height: 40,
                  fontWeight: 800,
                }}
              >
                <Input placeholder="Filter Confirmation ID" />
                <InputGroup.Button>
                  <SearchIcon />
                </InputGroup.Button>
              </InputGroup> */}
              <div
                style={{
                  maxWidth: "400px",
                  fontWeight: "600",
                  paddingTop: "0px",
                }}
              >
                <Tabs
                  style={{ maxWidth: "50" }}
                  defaultActiveKey={tabsActiveKey}
                  onSelect={(e) => setSelectedReportType(e)}
                >
                  <Tabs.Tab eventKey="All" title="All"></Tabs.Tab>
                  <Tabs.Tab eventKey="Invoiced" title="Invoiced"></Tabs.Tab>
                  <Tabs.Tab eventKey="Reasons" title="Reasons"></Tabs.Tab>
                  <Tabs.Tab
                    eventKey="NotOrdered"
                    title="Not Ordered"
                  ></Tabs.Tab>
                  <Tabs.Tab
                    eventKey="OrderExtra"
                    title="Order Extra"
                  ></Tabs.Tab>
                  <Tabs.Tab eventKey="NotSent" title="Not Sent"></Tabs.Tab>
                </Tabs>
              </div>
            </>
          </div>
          <div>
            <div className="d-flex flex-nowrap justify-content-end align-items-center ">
              {/* <div
                className="mx-2 filter"
                onClick={() => {
                  setShowFilter(!showFilter);
                }}
              >
                <Icon icon="material-symbols:filter-alt-outline-sharp" />
                Filters
              </div> */}

              <Dropdown
                renderToggle={(_props, _ref) => (
                  <div className="filter" ref={_ref} {..._props}>
                    <Icon icon="pajamas:export" /> Export
                  </div>
                )}
                className="ms-2 me-0 button-fixed"
                appearance="link"
                placement="bottomEnd"
              >
                <Dropdown.Item
                  icon={<FileDownloadIcon />}
                  onClick={() => {
                    exportToExcel(
                      selectedReportTableName,
                      `Out Of Stock Report ${selectedReportType} Store: ${
                        userContext && userContext.store
                          ? userContext.store
                          : userStore
                      }`
                    );
                  }}
                >
                  Export to Excel
                </Dropdown.Item>
              </Dropdown>
            </div>
          </div>
          <TableComponent
            isFromModal={false}
            tableDetails={selectedReportConstantName}
            reportList={selectedReportTableName}
            iconColumn={"description"}
            onTableRowClick={(e) => {
              getDetailRecord(e);
            }}
            reportType={""}
            totalTableRow={{}}
            isTotalRowRequired={false}
          />
        </div>

        <Modal size={"calc(100% - 120px"} open={open} onClose={handleClose}>
          <Modal.Header>
            <Modal.Title>
              {" "}
              <div style={{ textAlign: "center" }}>
                <Modal.Title>Detail Out Of Stock</Modal.Title>
              </div>
              <div className="bg-container row m-0 mt-3 p-3">
                <div className="col-3 p-2 reportDescItem">
                  <>
                    <div className="icon">
                      <Icon icon="material-symbols:store-outline" />
                    </div>
                    <div className="label">
                      <p className="m-0">Description</p>
                      <p className="m-1">
                        {detailRowData && detailRowData["description"]}
                      </p>
                    </div>
                  </>
                </div>
                <div className="col-3 p-2 reportDescItem">
                  <>
                    <div className="icon">
                      <Icon icon="material-symbols:store-outline" />
                    </div>
                    <div className="label">
                      <p className="m-0">Department</p>
                      <p className="m-1">
                        {detailRowData &&
                          detailRowData["department_Store_Name"]}
                      </p>
                    </div>
                  </>
                </div>

                <div className="col-2 p-2 reportDescItem">
                  <>
                    <div className="icon">
                      <Icon icon="material-symbols:store-outline" />
                    </div>
                    <div className="label">
                      <p className="m-0">Item ID</p>
                      <p className="m-1">
                        {detailRowData && detailRowData["item_ID"]}
                      </p>
                    </div>
                  </>
                </div>
                <div className="col-2 p-2 reportDescItem">
                  <>
                    <div className="icon">
                      <Icon icon="material-symbols:store-outline" />
                    </div>
                    <div className="label">
                      <p className="m-0">UPC</p>
                      <p className="m-1">
                        {detailRowData && detailRowData["upc"]}
                      </p>
                    </div>
                  </>
                </div>
                <div className="col-2 p-2 reportDescItem">
                  <>
                    <div className="icon">
                      <Icon icon="material-symbols:store-outline" />
                    </div>
                    <div className="label">
                      <p className="m-0">Pack</p>
                      <p className="m-1">
                        {detailRowData && detailRowData["pack"]}
                      </p>
                    </div>
                  </>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TableComponent
              isFromModal={true}
              tableDetails={ReportOOSConstants["DetailConstants"]}
              reportList={detailData}
              iconColumn={""}
              onTableRowClick={() => {}}
              reportType={""}
              totalTableRow={{}}
              isTotalRowRequired={false}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default ReportOutOfStockComp;
